<template>
  <div class="downloadbox">
    <div class="banner">
      <p class="dowtitle">资源下载中心</p>
      <p>联盟成员共享的威胁情报资源、工具等</p>
    </div>
    <div class="main">
      <div class="mian-content">
        <p class="warmtip">
          <span>温馨提示：</span>下载资源需<span class="link" @click="gologin">登录</span>
          ，并且<span class="link" @click="informatShow">完善基本信息</span>。
        </p>
        <!-- 失陷检测离线包 -->
        <FallDown/>
          <!-- 挖矿情报离线包 -->
        <IntelligenceDown/>
      </div>
    </div>
    <UserinfoDialog
      :dialogFormVisible="dialogFormVisible"
      @closeMoule="closeMoule"
      @reloaduserinfo='reloaduserinfo'

    />
  </div>
</template>

<script>

import { User } from '@/api/api.js';
import { tipDialogtext } from '@/utils/helper.js';
import UserinfoDialog from '@/components/userinfo-dialog.vue';
import FallDown from '@/components/resource-down/fall-down.vue';
import IntelligenceDown from '@/components/resource-down/intelligence-down.vue';

export default {
  name: '',
  data () {
    return {
      count: 0,
      total: 0,
      dialog: false,
      currentPage: 1,
      listdata: [],
      value1: '',
      radio: '',
      dialogcont: '',
      centerDialogVisible: false,
      dialogFormVisible: false,
      logtoken: true,
      userall: true,
      useremail: '',
      choiceDate0: '',
      downhref: '',
      itemshow: true,
      dialogVisibleShow: true,
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          let choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 1
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 1
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      centerTitle: '',
      deviceFormData: {
        time: []
      }
    };
  },
  filters: {
    size (value) {
      return (value / (1024 * 1024)).toFixed(2) + 'M';
    }
  },
  components: {
    UserinfoDialog, FallDown, IntelligenceDown
  },
  watch: {
    'deviceFormData.time' (newVal) {
      if (newVal == null) {
        this.deviceFormData.time = [];
      }
    }
  },
  methods: {
    // down (type) {
    //   console.log(this.radio, 'radio')
    //   this.userInfoisall(false);
    //   if (!this.logtoken) {
    //     this.$message.error('用户未登录，请先登录');
    //   } else if (!this.userall) {
    //     this.$message.error('请先完善基本信息');
    //     setTimeout(() => {
    //       this.dialogFormVisible = true;
    //     }, 500);
    //   } else if (type === 'local') {
    //     const a = document.createElement('a'); // 创建a标签
    //     a.setAttribute('download', ''); // download属性
    //     a.setAttribute('href', this.listdata[this.radio].url); // href链接
    //     console.log(this.listdata[this.radio].url, 'url')
    //     a.click(); // 自执行点击事件
    //   } else {
    //     this.userInfoisall(true);
    //     setTimeout(() => {
    //       this.dialogVisible('application');
    //     }, 1000)
    //   }
    // },
    gologin () {
      if (!this.logtoken) {
        this.$router.push({
          path: '/login'
        });
      } else {
        this.$message.success('您已登录！');
      }
    },

    closeMoule (e) {
      this.dialogFormVisible = e;
    },
    informatShow () {
      if (!this.logtoken) {
        this.$message.error('您未登录，请登录后完善。');
      } else {
        this.dialogFormVisible = true;
      }
    },
    dialogVisible (type) {
      if (this.dialogVisibleShow) {
        this.centerDialogVisible = true;
        this.centerTitle = tipDialogtext[type].title;
        this.dialogcont = tipDialogtext[type].content({ email: this.useremail });
      }
    },
    // 用户信息是否完善
    userInfoisall (type) {
      let params = {
        send_email: type
      };
      User.getUserInfo(params).then(({ data }) => {
        if (data.status === 10000) {
          this.useremail = data.data.email;
          if (
            data.data.company &&
            data.data.realname &&
            data.data.phone &&
            data.data.email
          ) {
            this.userall = true;
          } else {
            this.userall = false;
          }
        } else if (data.status === 10001) {
          this.logtoken = false;
        } else if (data.status === 10004) {
          this.$message.error(data.message);
          this.dialogVisibleShow = false
        }
      });
    },
    reloaduserinfo (e) {
      if (e) {
        this.userInfoisall()
        this.getListdata(this.currentPage);
      }
    }
  },
  created () {
    this.userInfoisall(false);
  }
};
</script>

<style lang='scss' scoped>
.banner {
  color: #fff;
  background: url("~@/assets/images/bannerimg.png");
  background-size: 100%;
  height: 200px;
  display: flex;

  flex-direction: column;
  p {
    font-weight: 900;
  }
}
.dowtitle {
  font-size: 30px;
  margin-bottom: 15px;
  margin-top: 95px;
}
.main {
  background: #f2f2f2;
}
.warmtip {
  padding: 40px 0;
  font-weight: 500;
  font-size: 14px;
  span {
    color: #f1a13d;
  }
  .link {
    color: #4473f6;
    display: inline-block;
    border-bottom: 1px solid #4473f6;
    cursor: pointer;
    text-decoration: none;
  }
}
.mian-content {
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding-bottom: 100px;
}
.downcont {
  display: flex;
  height: 480px;
}

.downcont-left {
  flex: 1;
  color: #fff;
  background: #4473f6;
  .left-header img {
    width: 115px;
    height: 58px;
  }
  h1 {
    font-size: 18px;
    text-align: center;
    margin: 25px 0;
  }
  ul {
    padding: 0 15px;
    font-weight: 500;
    li {
      line-height: 36px;
      font-size: 14px;
    }
  }
}
.downcont-right {
  flex: 4;
  background: #fff;
  .right-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 30px 20px 25px;
  }
  .right-cont {
    display: flex;
    flex-wrap: wrap;
    gap: 1.9%;
    padding-left: 30px;
    height: 230px;
    .right-item {
      width: 32%;
      padding: 15px 0 0 0;
      position: relative;
    }
    .recommend {
      position: absolute;
      top: 11px;
      right: 5%;
      color: #fff;
      font-size: 12px;
      display: inline-block;
      background: #4473f6;
      padding: 3px;
      border-radius: 5px;
    }
  }
  .right-cont2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.right-cont-nodata{
  height: 230px;
  text-align: center;
  padding: 40px;
}
.pagination {
  padding: 30px 60px 0 0;
  text-align: right;
}
.left-footer {
  margin-top: 18%;
  display: flex;
  justify-content: space-around;
  span {
    border-bottom: 1px solid #fff;
    font-size: 15px;
  }
}
/deep/.el-radio__inner::after {
  width: 14.5px;
  height: 14.5px;
  background-image: url(~@/assets/images/selected.png);
  background-size: cover;
  border: 0;
}
.md5 {
  margin-left: 27px;
  margin-top: 8px;
  font-size: 12px;
}

.bold {
  font-weight: 900;
}
.big {
  font-size: 18px;
}
.el-button--default {
  color: #4473f6;
  border: 1px solid #4473f6;
}
.el-button--primary {
  background: #4473f6;
}
.right-footer {
  margin-top: 4%;
  display: flex;
  justify-content: space-around;
}
.el-button {
  margin: 0 10px 0 0;
  padding: 10px 80px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #000;
}
/deep/ .el-dialog__body {
  color: #000;
  line-height: 25px;
}
/deep/.el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
/deep/.el-dialog__header {
  text-align: left;
  background: #4473f6;
  padding: 10px 25px;
}
/deep/.el-dialog__headerbtn {
  top: 13px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.riledialog {
  position: relative;
  .el-button {
    padding: 10px 20px;
    margin-left: 85%;
    margin-top: 20px;
  }
}
</style>
